import React, {Component} from 'react';
import PropTypes from "prop-types";
import Api from "../../utils/Api";
import SearchField from "../../utils/SearchField";
import TableContainer from "../../utils/TableContainer";
import Timeformat from "../../utils/Timeformat";
import StaticFunctions from "../../utils/StaticFunctions";
import LoadingSplash from "../../globalComponents/LoadingSplash";
import moment from "./CompanyOverviewContainer";

class DataCollectorOverviewContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        changeView: PropTypes.func.isRequired,
    };

    constructor(props) {

        super(props);

        this.state = {
            currentCompany: this.props.baseData.companies.currentCompany,
            filterString: '',
            currentDataCollectors: null,
            filteredDataCollectors: null,
        };

        this.api = new Api();

        this.translate = this.props.baseData.translate;
        this.userLanguage = this.props.baseData.userData.language;
        this.timeFormats = this.props.baseData.languages.getFormatByLanguage(this.userLanguage);

        this.requestCompanies = this.requestCompanies.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.onCancel = this.onCancel.bind(this);

    }

    componentWillMount() {

        this.requestCompanies();

    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.currentCompany.id !== this.props.currentCompany.id) {
            this.setState({
                currentCompany: nextProps.currentCompany
            }, this.requestCompanies);
        }

    }

    requestCompanies() {

        const params = {
            action: 'getDataCollectorOverview',
            currentCompanyId: this.state.currentCompany.id,
            companyId: this.props.baseData.companies.currentCompany.id,
            userId: this.props.baseData.userData.id,
        };

        const callback = function(res) {
            if (res) {
                this.setState({
                    currentDataCollectors: res,
                    filteredDataCollectors: this.getTableData(res),
                });
            }
        }.bind(this);

        this.api.request('AdminFunctions', params, callback, null);

    }

    onSearch(name, value) {

        const tableData = this.getTableData(this.state.currentDataCollectors);
        const filteredData = StaticFunctions.findSubstringInObjArray(tableData, value);

        this.setState({
            filteredDataCollectors: filteredData
        });

    }

    onCancel() {

        this.setState({
            filteredDataCollectors: this.getTableData(this.state.currentDataCollectors),
        });

    }

    changeView(view, datacollector = null) {

        if (this.props.changeView) this.props.changeView(view, datacollector);

    }

    applyFilter(rows) {

        const filterString = this.state.filterString;
        const filterFields = ['id', 'company', 'location', 'machineCount', 'clientVersion', 'localIpPort', 'dateCreated', 'lastSeen'];

        if (!filterString) return rows;

        return rows.filter((row)=>{
            return filterFields.some((field)=>{
                return StaticFunctions.substringExists(row[field], filterString);
            });
        });

    }

    getCompanyNameById(id) {

        const companies = this.props.baseData.companies.companies;

        if (companies) {
            for (let ix in companies) {
                let c = companies[ix];

                if (String(c.id) === String(id)) return c.name;
            }
        }

        return id;

    }

    getLocationNameById(id) {

        const locations = this.props.baseData.locations;

        if (locations) {
            for (let ix in locations) {
                let c = locations[ix];

                if (String(c.id) === String(id)) return c.name;
            }
        }

        return id;

    }

    getTableData(rawData) {

        rawData = (rawData) ? rawData : this.state.currentDataCollectors;

        const timezone = this.props.baseData.companies.currentCompany.timezone;
        const rows = [];

        for (let i = 0; i < rawData.length; i++) {
            let rowTemp = rawData[i];
            let company = this.getCompanyNameById(rowTemp.id_company);
            let dateCreated = (rowTemp.date_created) ? Timeformat.fromUnix(rowTemp.date_created).getFormatedDate(this.timeFormats.datetime, timezone) : null;
            let lastSeen = (rowTemp.last_seen) ? Timeformat.fromUnix(rowTemp.last_seen).getFormatedDate(this.timeFormats.datetime, timezone) : null;

            let localIpPort = ((rowTemp.local_ip1) ? rowTemp.local_ip1 : '') + ':' + ((rowTemp.local_tcp_port) ? rowTemp.local_tcp_port : '');

            rowTemp.company = (company) ? company + ' (' + rowTemp.id_company + ')' : '*** ' + this.translate('unallocated') + ' ***';
            rowTemp.location = this.getLocationNameById(rowTemp.id_location);
            rowTemp.localIpPort = (localIpPort !== ':') ? localIpPort : null;
            rowTemp.formatedDateCreated = dateCreated;
            rowTemp.formatedLastSeen = lastSeen;

            rows.push(rowTemp);

            /*rows.push({
                id: rowTemp.id,
                company: (company) ? company : '*** ' + this.translate('unallocated') + ' ***',
                id_company: this.getLocationNameById(rowTemp.id_company),
                id_location: this.getLocationNameById(rowTemp.id_location),
                machine_count: rowTemp.machine_count,
                client_version: rowTemp.client_version,
                localIpPort: (localIpPort !== ':') ? localIpPort : null,
                date_created: rowTemp.date_created,
                formatedDateCreated: dateCreated,
                last_seen: rowTemp.last_seen,
                formatedLastSeen: lastSeen
            });*/
        }

        return rows;

    }

    getCompanyColumns() {

        return [
            {
                key: 'id',
                nameKey: 'id',
                sortType: 'int',
            },
            {
                key: 'company',
                nameKey: 'company',
                sortType: 'string',
            },
            {
                key: 'location',
                nameKey: 'location',
                sortType: 'string',
            },
            {
                key: 'machineCount',
                nameKey: 'machinesDataCollector',
                classes: 'text-right',
                sortType: 'int',
            },
            {
                key: 'clientVersion',
                nameKey: 'clientVersion',
                sortType: 'string',
            },
            {
                key: 'localIpPort',
                nameKey: 'localIpPort',
                sortType: 'string',
            },
            {
                key: 'dateCreated',
                nameKey: 'dateCreated',
                sortType: 'datetime',
            },
            {
                key: 'lastSeen',
                nameKey: 'lastSeen',
                sortType: 'datetime',
            },
            {
                key: 'options',
                name: this.translate('options'),
            },
        ];

    }

    getCompanyRows() {

        const data = (this.state.filteredDataCollectors) ? this.state.filteredDataCollectors : [];
        const rows = [];

        for (let i = 0; i < data.length; i++) {
            let rowTemp = data[i];

            rows.push({
                id: rowTemp.id,
                company: rowTemp.company,
                location: rowTemp.location,
                machineCount: rowTemp.machine_count,
                clientVersion: rowTemp.client_version,
                localIpPort: rowTemp.localIpPort,
                dateCreated: rowTemp.formatedDateCreated,
                lastSeen: rowTemp.formatedLastSeen,
                options: <div className="tableOptions">
                    <a className="optionSearch" onClick={() => this.changeView('edit', rowTemp)} title={this.translate('showDetails')}>&nbsp;</a>
                </div>
            });
        }

        return rows;

    }

    renderAddButton() {

        if (!this.props.baseData.checkUserRole('superadmin')) return null;

        return (
            <div className="flr">
                <div className="bottomLinks">
                    <a className="prewLink" onClick={(e) => this.changeView('add')}>{this.translate('addNewDataCollector')}</a>
                </div>
            </div>
        );

    }

    render() {

        if (!this.state.currentDataCollectors) return <LoadingSplash color={'dark'} />;

        const companyColumns = this.getCompanyColumns();
        const companyRows = this.getCompanyRows();

        const dataCount = companyRows.length;
        const countText = (dataCount === 1) ? this.translate('dataCollector') : this.translate('dataCollectors');

        const addButton = this.renderAddButton();

        return (
            <div>
                <div className="ma-bo-20 clearfix">
                    <div className="clearfix">
                        <nav>
                            <h1>{this.translate('selectDataCollector')}</h1>

                            <SearchField
                                baseData={this.props.baseData}
                                name="searchDataCollectorOverview"
                                placeholder={this.translate('searching')}
                                styles={{padding: 0}}
                                onSearch={this.onSearch}
                                onCancel={this.onCancel}
                            />
                        </nav>
                    </div>

                    <div className="clearfix">
                        <div className="fll">
                            <p>{dataCount} {countText} {this.translate('found')}. {this.translate('connectNewDataCollectorNote')}</p>
                        </div>

                        {addButton}
                    </div>

                    <div className="clearfix">
                        <TableContainer
                            baseData={this.props.baseData}
                            columns={companyColumns}
                            rows={companyRows}
                            fillGaps="-"
                        />
                    </div>
                </div>

                <div className="bottomLinks clearfix">
                    <a className="prewLink" onClick={() => this.props.baseData.pageNavigation('admin')}>{this.translate('backToOverview')}</a>
                </div>
            </div>
        );

    }

}

export default DataCollectorOverviewContainer;
